export const MAINTENANCE_ERROR_MSG = "maintenance_active";
